<template>
    <div
        class="group relative overflow-hidden rounded-lg shadow-sm hover:shadow-lg transition duration-300"
        :style="{
            paddingTop: '100%',
            ...cardShapeStyle
        }"
    >
        <img
            :src="imageUrl || defaultImageUrl"
            :alt="imageAlt"
            class="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition duration-500"
        />

        <!-- Gradiente -->
        <div
            class="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70"
        ></div>

        <template v-if="draggable">
            <div
                class="product-drag-handle absolute inset-0 z-20 flex items-center justify-center cursor-grab bg-black bg-opacity-60"
            >
                <span
                    class="flex items-center justify-center w-10 h-10 rounded-full bg-black bg-opacity-75 text-white text-xl leading-none select-none"
                >
                    ⠿
                </span>
            </div>
        </template>

        <template v-else>
            <!-- Overlay -->
            <div
                class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            >
                <!-- Fondo oscuro -->
                <div class="absolute inset-0 bg-black opacity-60"></div>

                <!-- Botones -->
                <div class="relative z-10 flex flex-col space-y-2 px-4 w-full">
                    <button
                        class="w-full py-2 rounded-md bg-white text-gray-800 text-sm font-medium hover:bg-gray-100 focus:outline-none"
                        @click.stop="$emit('edit', product)"
                    >
                        Editar
                    </button>

                    <button
                        v-if="!readOnly"
                        class="w-full py-2 rounded-md text-white text-sm font-medium hover:opacity-90 focus:outline-none"
                        :class="
                            product.active
                                ? 'bg-theme-danger'
                                : 'bg-theme-success'
                        "
                        @click.stop="$emit('toggle-publish', product)"
                    >
                        {{ product.active ? "Ocultar" : "Publicar" }}
                    </button>

                    <!-- billing-productos-displaymode-permisos: en modo
                    solo lectura (Free con productos guardados de antes) la
                    escritura queda bloqueada, con candado en vez de oculta. -->
                    <button
                        v-else
                        class="w-full py-2 rounded-md bg-theme-card text-theme-muted text-sm font-medium focus:outline-none"
                        @click.stop="$emit('locked', product)"
                    >
                        🔒 {{ product.active ? "Ocultar" : "Publicar" }}
                    </button>
                </div>
            </div>
        </template>

        <!-- Información -->
        <div
            class="absolute bottom-0 left-0 right-0 p-3 text-left transition-opacity duration-200"
        >
            <div class="text-white font-semibold truncate">
                {{ product.name }}
            </div>

            <ProductPriceViewer
                v-slot="{ isOffer }"
                :price="resolvedReference.price"
                :price-offer="resolvedReference.priceOffer"
            >
                <div class="text-xs text-white opacity-90">
                    {{ formatCurrency(displayPrice(isOffer)) }}
                </div>
            </ProductPriceViewer>
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";
import { formatCurrency } from "@/common/lib/money";

import ProductPriceViewer from "@/components/catalog/ProductPriceViewer.vue";

export default {
    name: "EditorProductCard",
    components: { ProductPriceViewer },
    props: {
        product: {
            type: Object,
            required: true
        },
        draggable: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        colors: {
            type: Object,
            required: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        cardShapeStyle: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ["edit", "toggle-publish", "locked"],
    computed: {
        defaultImageUrl() {
            return DEFAULT_IMAGE_URL;
        },
        resolvedReference() {
            return this.product.references?.[0] ?? {};
        },
        imageUrl() {
            return this.resolvedReference.images?.[0]?.url;
        },
        imageAlt() {
            return this.resolvedReference.images?.[0]?.alt || this.product.name;
        }
    },
    methods: {
        formatCurrency,
        displayPrice(isOffer) {
            return isOffer
                ? this.resolvedReference.priceOffer
                : this.resolvedReference.price;
        }
    }
};
</script>
